// extracted by mini-css-extract-plugin
module.exports = {"Tooltip":"HtmlTooltip_Tooltip__15QnK"};